import PropTypes from "prop-types";
import React, { useState } from "react";


function Flashcard(props) {
  const { flashcard } = props;
  const [flip, setFlip] = useState(false);
  return (
    <div
      className={`flashcard ${flip ? "flip" : ""}`}
      onClick={() => setFlip(!flip)}
    >
    <div className="front">
      {flashcard.front}
    </div>
      <div className="back">{flashcard.back}</div>
    </div>
  );
}

PropTypes.propTypes = {
  front: PropTypes.string.isRequired,
  back: PropTypes.string.isRequired,
};
export default Flashcard;
